import { IInternal } from '../../types/internal';
import GeneralEnumService from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import { changeToZeroMoment } from '../timeHelpers';
import { numberWithCommas } from '../format';

export const groupDataToCsv = (data: IInternal[]): string[][] => {
    const groupData: string[][] = [['Date', 'Provider', 'Total', 'Description', 'Note', 'Status']];
    const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('InternalStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
    let totalAmount = 0;
    data.forEach((it) => {
        const internalDate = it.internalDate ? changeToZeroMoment(it.internalDate, 'MMM D, YYYY') : '';
        const providerTitle: string = it?.provider?.fullName ? `${it.provider.fullName}` : '';
        const description: string = it?.description ? `${it.description}` : '';
        const amountVal: number = it?.amount ? +it.amount : 0;
        const note: string = it?.note ? `${it.note}` : '';
        totalAmount += amountVal;
        let valuestatus: string | SelectObject | undefined = statusItems.find((its) => +its.value === +it.status);
        valuestatus = valuestatus ? `${valuestatus?.label}` : '';

        groupData.push([
            internalDate,
            providerTitle,
            `$${numberWithCommas(amountVal)}`,
            description,
            note,
            valuestatus,
        ]);
    });
    groupData.push(['', '', `$${numberWithCommas(totalAmount)}`, '', '', '']);
    return groupData;
};
